const VERY_LOW_PRIORITY = 100;

/**
 * Filters out the "General" group from the properties panel.
 * Runs AFTER the BpmnPropertiesProvider (priority 500) so the group exists to be removed.
 */
export default class GeneralGroupFilter {
  constructor(propertiesPanel) {
    propertiesPanel.registerProvider(VERY_LOW_PRIORITY, this);
  }

  getGroups(element) {
    return (groups) => {
      return groups.filter(g => g.id !== 'general');
    };
  }
}

GeneralGroupFilter.$inject = ['propertiesPanel'];
